import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import { checkType } from '../../../../utils/checkType'
import { numberWithCommas } from '../../../../utils/number'
const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class Payment extends Component {
	state = {
		detailProfile : [],
		dataNewProfile : {},
		loaddingDataNews : false,
		dataTabOne: [],
		dataTabTwo: [],
		dataTabThree: [],
		linkFund: null
	}

	fetchProfile = async () =>{
		const { client, location } = this.props

		try{
			let dataTabTwo = await client.query({
				query: Queries.fetchEmployeeProvidentFund,
			})

			let dataTabOne = await client.query({
				query: Queries.fetchEmployeeBankAccount,
			})

			let linkApplication = await client.query({
				query:Queries.fetchApplicationSetting
			})

			if(dataTabOne.data.fetchEmployeeBankAccount.length !== 0){
				await this.setState({
					dataTabOne:dataTabOne.data.fetchEmployeeBankAccount
				})
			}

			if(dataTabTwo.data.fetchEmployeeProvidentFund.length !== 0){
				await this.setState({
					dataTabTwo:dataTabTwo.data.fetchEmployeeProvidentFund
				})
			}

			await this.setState({
				linkFund:linkApplication.data.fetchApplicationSetting.linkFund
			})

		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
    }

	inputForm = (title, values) =>{
		return(
			<Col xs={24} sm={12} className="mb-3">
				<div className="">
					<Text>
						{ title }
					</Text><br></br>
					<Input 
						value={ values ? values : 'ไม่พบข้อมูล' } 
						className={ values ? values : 'font-italic' } 
						disabled={true}
					/>
				</div>
			</Col>
		)
	}

	tabsOne = () =>{
		const { dataTabOne } = this.state
		console.log(dataTabOne)
		return (
			<TabPane tab={'การจ่ายเงิน'} key="1" className="mb-0">
				<Row gutter={16}>
					<Col xs={24} md={24} className="mb-2">
						<strong className="color-red">
							การจ่ายเงิน
						</strong>
					</Col>
					{
						dataTabOne.length !== 0 &&
							dataTabOne.map((value, keys) =>{
								let reversed = "";
								if(value && value.bookNo){
									for (let i = 0; i < value.bookNo.length; i++) {
										if(i <= 2){
											reversed += 'x';
										}else if(i == 3 || i == 4 || i == 9){
											reversed += '-x';
										}else{
											reversed += value.bookNo[i];
										}
									}
								}

								let bankShortName = ''

								if(value || value.bank.bankShortName == 'KBANK'){
									bankShortName = 'ธนาคาร'
								}else{
									bankShortName = 'เงินสด'
								}
								
								return(
									<>
										{ this.inputForm('ช่องทางการจ่ายเงิน', bankShortName ? bankShortName : '') }
										{ this.inputForm('ชื่อธนาคาร', value ? value.bank.bankName ? value.bank.bankName : '' : '') }
										{ this.inputForm('ชื่อบัญชี', value ? value.bookName ? value.bookName : '' : '') }
										{ this.inputForm('เลขที่บัญชี', reversed ? reversed : '') }
									</>
								) 
							}
						)
						||
						<>
							{ this.inputForm('ช่องทางการจ่ายเงิน', '') }
							{ this.inputForm('ชื่อธนาคาร','')}
							{ this.inputForm('ชื่อบัญชี','')}
							{ this.inputForm('เลขที่บัญชี','')}
						</>
					}
				</Row>
			</TabPane>
		)
	}

	tabsTwo = () =>{
		const { dataTabTwo, linkFund } = this.state
		// console.log('123',dataTabTwo.length !== 0 ? dataTabTwo.memberStatus.toLowerCase() : '')
		return (
			<TabPane tab={'กองทุนสำรองเลี้ยงชีพ'} key="2" className="mb-0">
				<Row gutter={16}>
					{
						dataTabTwo.length !== 0 &&
							(
								dataTabTwo.memberStatus.toLowerCase() == 'member' && dataTabTwo.isDeduct == 1 &&
									<>
										<Col xs={24} md={24} className="mb-2">
											<strong className="color-red">
												กองทุนสำรองเลี้ยงชีพ
											</strong>
										</Col>
										{ this.inputForm('รหัสสมาชิก', dataTabTwo ? dataTabTwo.accMemberCode : '') }
										{ this.inputForm('หักเงินสะสมกองทุนสำรองฯ', dataTabTwo ? dataTabTwo.isDeduct ? dataTabTwo.isDeduct == '0' ? 'ไม่หัก' : 'หัก' : '' : '' ) }
										{ this.inputForm('วันที่เป็นสมาชิก', dataTabTwo ? dataTabTwo.provStartDate ? checkType(dataTabTwo.provStartDate) : '' : ''  ) }
										{ this.inputForm('วันที่สิ้นสุดเป็นสมาชิก', dataTabTwo ? dataTabTwo.provEndDate ? checkType(dataTabTwo.provEndDate) : '' : '' ) }
										{ this.inputForm('ลูกจ้างหักเงินสะสม ร้อยละ', dataTabTwo ? dataTabTwo.provEmployeeDeduct ? numberWithCommas(dataTabTwo.provEmployeeDeduct.toFixed(2).toString()) : '' : '' ) }
										{ this.inputForm('นายจ้างหักเงินสมทบ ร้อยละ', dataTabTwo ? dataTabTwo.provEmployerDeduct ? numberWithCommas(dataTabTwo.provEmployerDeduct.toFixed(2).toString()) : '' : '' ) }

										<Col xs={24} md={24} className="mt-3" align="center">
											<p className="mb-4">ศึกษาข้อมูลเพิ่มเติมของกองทุนฯ</p>
											<a href={linkFund} 
												className="btn" 
												target="_blank" 
												style={{
														color:"#fff",
														backgroundColor:"#bad0cb",
														padding:"6px 40px  4px",
														borderRadius:"5px"
													}}>
												คลิกที่นี่
											</a>
										</Col>
									</>
								||
									<>
										<div style={{ textAlign: 'center', borderRadius: "10px" }}>
											<Text className="color-gray" >ท่านไม่ได้เป็นสมาชิกกองทุนสำรองเลี้ยงชีพ</Text>
										</div>
									</>
							)
						||
							<div style={{ textAlign: 'center', borderRadius: "10px" }}>
								<Text className="color-gray" >ท่านไม่ได้เป็นสมาชิกกองทุนสำรองเลี้ยงชีพ</Text>
							</div>
					}
				</Row>
			</TabPane>
		)
	}

	tabThree = () =>{
		const { dataTabThree } = this.state
		return (
			<TabPane tab={'รายได้-รายหักประจำ'} key="3" className="mb-0">
				<Row gutter={16}>
					{	
						dataTabThree.income &&
						dataTabThree.income.length !== 0&&
						dataTabThree.income.map((value, key)=>
							<>
								<Col xs={24} md={24} className="mb-2">
									<strong className="color-red">
										รายได้
									</strong>
								</Col>
								{ this.inputForm('ชื่อรายได้', value ? value.incomeDeduct.incomeDeductName : '') }
								{ this.inputForm('จำนวนเงิน', value ? numberWithCommas(value.incomeDeductAmount.toFixed(2).toString()) : '') }
								{
									value.isCancel == 1 &&
									<>
										{ this.inputForm('วันที่เริ่มต้น', value ? value.startDate : '') }
										{ this.inputForm('วันที่สิ้นสุด', value ? value.endDate : '') }
										{ this.inputForm('สาเหตุ', value ? value.remark : '') }
									</>
								}
								
							</>
						)	
					}
					{	
						dataTabThree.deduct &&
						dataTabThree.deduct.length !== 0 &&
						dataTabThree.deduct.map((value, key)=>
							<>
								<Col xs={24} md={24} className="mb-2">
									<strong className="color-red">
										รายหัก
									</strong>
								</Col>
								{ this.inputForm('ชื่อรายได้', value ? value.incomeDeduct.incomeDeductName : '') }
								{ this.inputForm('จำนวนเงิน', value ? numberWithCommas(value.incomeDeductAmount.toFixed(2).toString()) : '') }
								{ this.inputForm('ประเภทการจ่าย', value ? value.incomeDeductType : '') }
							</>
						)	
					}
					{
						dataTabThree.length !== 0 &&
						<>
							{
								(dataTabThree.income.length == 0 && dataTabThree.deduct.length == 0) &&
								<Col xs={24} sm={24} align="center">
									<Text>
										ไม่พบรายได้-รายหัก ประจำ
									</Text>
								</Col>
							}
						</>
						||
						dataTabThree.length == 0 &&
						<Col xs={24} sm={24} align="center">
							<Text>
								ไม่พบรายได้-รายหัก ประจำ
							</Text>
						</Col>
					}
				</Row>
			</TabPane>
		)
	}

	async componentDidMount(){
		await this.fetchProfile()
		const newsDataProfile = '';
		const { history, location, match, staticContext } = this.props
		const { detailProfile } = this.state
	}
	render() {
		const { history, location, match, staticContext } = this.props
		const { loaddingDataNews, dataNewProfile, dataTabOne, dataTabTwo, dataTabThree} = this.state

		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
							{ this.tabsOne() }
							{/* { this.tabsTwo() } */}
							{/* { this.tabThree() } */}
						</Tabs>
					</div>
				</div>
			</Container>
		)
	}
}

Payment.propTypes = {
	//
}

export default withApollo(Payment)